import { User } from '../user.model';

export class UserDetailsDialog {
    public user: User;
    public activeTab: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-details/user-details-dialog.model.ts